"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = createEnrichReducers;
const redux_1 = require("redux");
const attributes_1 = __importDefault(require("./attributes"));
const categories_1 = __importDefault(require("./categories"));
const enrich_ai_1 = require("./enrich-ai");
const facet_navigation_panel_1 = __importDefault(require("./facet-navigation-panel"));
const organizations_1 = __importDefault(require("./organizations"));
const products_1 = __importDefault(require("./products"));
const refinements_1 = __importDefault(require("./refinements"));
const taxonomy_classes_1 = __importDefault(require("./taxonomy-classes"));
const user_1 = __importDefault(require("./user"));
const store_1 = require("../../enrich-ai/store");
// TODO: move all Enrich AI Redux stuff to the corresponding folder
const enrichAIReducers = (0, redux_1.combineReducers)(Object.assign(Object.assign({}, (0, enrich_ai_1.createDeprecatedEnrichAIReducers)()), (0, store_1.createEnrichAIReducers)()));
function createEnrichReducers() {
    return (0, redux_1.combineReducers)({
        organizations: organizations_1.default,
        products: products_1.default,
        categories: categories_1.default,
        taxonomyClasses: taxonomy_classes_1.default,
        attributes: attributes_1.default,
        refinements: refinements_1.default,
        user: user_1.default,
        facetNavigationPanel: facet_navigation_panel_1.default,
        enrichAI: enrichAIReducers,
    });
}
